import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Constant from "./Constant";
import SelectAsync from 'react-select/async';

export default class Stuff extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            tab: 0
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.getForm();
    }
    getForm() {
        this.addKeyDown();
        this.httpPost("api/v1/stuff/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/stuff/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            form: this.state.data.record,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setType(type) {
        this.state.data.record.type = type;
        this.setState({ data: this.state.data });
    }
    setGroup(e) {
        if (e.value == -1) {
            this.state.data.record.groupId = this.defaultGuid();
            this.state.data.record.groupName = '';
            this.showComponents({ component: <Constant Type={2} Caller={this} FromAutoComplete={true} /> });
            return;
        }
        this.state.data.record.groupId = e.value;
        this.state.data.record.groupName = e.label;
        this.setState({ data: this.state.data });
    }
    setDefaultWarehouse(e) {
        this.state.data.record.defaultWarehouseId = e.value;
        this.state.data.record.warehouseName = e.label;
        this.setState({ data: this.state.data });
    }
    setUnit(e) {
        this.state.data.record.unitId = e.value;
        this.state.data.record.unitName = e.label;
        this.setState({ data: this.state.data });
    }    
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                                <button type="button" className="close hand" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">فرم کالا/خدمات</h4>
                            </div>
                            <div className="modal-body">
                                <ul className="nav nav-tabs">
                                    <li role="presentation" className={this.state.tab === 0 ? "hand active" : "hand"}><a onClick={e => this.setState({ tab: 0 })} data-toggle="tab" target="_self" aria-expanded="false">اطلاعات</a></li>
                                    {/*<li role="presentation" className={this.state.tab === 1 ? "hand active" : "hand"}><a onClick={e => this.setState({ tab: 1 })} data-toggle="tab" target="_self" aria-expanded="false">انبارها</a></li>*/}
                                    {/*<li role="presentation" className={this.state.tab === 2 ? "hand active" : "hand"} ><a onClick={e => this.setState({ tab: 2 })} data-toggle="tab" target="_self" aria-expanded="false">ساخت</a></li>*/}
                                </ul>
                                <div className="tab-content">
                                    <div className={"tab-pane fade in " + (this.state.tab === 0 ? "active" : "")}>
                                        <div className="row">
                                        <div className="col-sm-3">
                                            <label className="title1">نوع</label>
                                            <select defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)} className="form-control input-sm">
                                                <option value='1'>کالا</option>
                                                <option value='2'>خدمت</option>
                                                {/*<option value='3'>کالای تولید</option>*/}
                                            </select>
                                        </div>
                                        <div className="col-xs-9">
                                            <div className="form-group">
                                                <label for="name" className="title1">عنوان <span className="red">*</span></label>
                                                <input defaultValue={this.state.data.record.farsiName} onChange={e => this.state.data.record.farsiName = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label for="code" className="title1">بارکد</label>
                                                    <input defaultValue={this.state.data.record.barcode} onChange={e => this.state.data.record.barcode = e.target.value} autocomplete="off" type="text" autofill="false" className="form-control input-sm" maxlength="48" />
                                                </div>
                                            </div>
                                            <div className="col-xs-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">کد <span className="red"></span></label>
                                                    <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                                </div>
                                            </div>
                                            <div className="col-xs-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">قیمت <span className="red"></span></label>
                                                    <input defaultValue={this.state.data.record.price} onChange={e => this.state.data.record.price = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                                </div>
                                            </div>
                                            <div className="col-xs-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">ارزش افزوده <span className="red"></span></label>
                                                    <input defaultValue={this.state.data.record.taxRate} onChange={e => this.state.data.record.taxRate = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                                </div>
                                            </div>
                                            <div className="col-xs-3">
                                                <div className="form-group">
                                                <label for="name" className="title1">مقدار واحد <span className="red"></span></label>
                                                <input defaultValue={this.state.data.record.amount} onChange={e => this.state.data.record.amount = parseFloat(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                                </div>
                                            </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label for="name" className="title1">شرح </label>
                                                <input defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} type="text" className="form-control input-sm" maxlength="400" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                            <div className="col-xs-12">
                                                <div className="form-group">
                                                    <label for="name" className="title1">یادداشت </label>
                                                    <textarea defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} type="text" className="form-control input-sm" maxlength="400"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label className="title1">گروه </label>
                                                    <SelectAsync
                                                        value={this.state.data.record.groupId != this.defaultGuid() ? [{ value: this.state.data.record.groupId, label: this.state.data.record.groupName }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب گروه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback, 2, 1)}
                                                        onChange={e => this.setGroup(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label className="title1">انبار کالا</label>
                                                    <SelectAsync
                                                        value={this.state.data.record.defaultWarehouseId != this.defaultGuid() ? [{ value: this.state.data.record.defaultWarehouseId, label: this.state.data.record.warehouseName }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب انبار"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadWarehousesOptions(inputValue, callback)}
                                                        onChange={e => this.setDefaultWarehouse(e)}
                                                    />
                                                </div>
                                        </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label for="code" className="title1">واحد <span className="red">*</span></label>
                                                    <SelectAsync
                                                    value={this.state.data.record.unitId != this.defaultGuid() ? [{ value: this.state.data.record.unitId, label: this.state.data.record.unitName }] : null}
                                                        isMulti={false}
                                                    placeholder="انتخاب واحد"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadUnitsOptions(inputValue, callback)}
                                                    onChange={e => this.setUnit(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="separator1 mr-t-10"></div>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="OrderPoint" className="title1">نقطه سفارش
                                                    </label>
                                                    <input defaultValue={this.state.data.record.recordPoint} onChange={e => this.state.data.record.recordPoint = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="OrderCount" className="title1">تعداد سفارش </label>
                                                    <input defaultValue={this.state.data.record.recordCount} onChange={e => this.state.data.record.recordCount = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label for="OrderCount" className="title1">شماره مالیاتی </label>
                                                    <input defaultValue={this.state.data.record.taxNumber} onChange={e => this.state.data.record.taxNumber = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className={"tab-pane fade in " + (this.state.tab === 1 ? "active" : "")}>
                                        <div className="row">
                                            <div className="form-group">
                                                <label for="code" className="title1">انبارهای کالا <span className="red">*</span></label>
                                                <div id="comboRelatedWarehouse"></div>
                                            </div>
                                            <div className="panel panel-primary">
                                                <div className="panel-heading">
                                                    <h3 className="panel-title">انبار کالاهای مربوطه را انتخاب نمایید </h3>
                                                </div>
                                                <div className="panel-body" id="related_warehouse"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"tab-pane fade in " + (this.state.tab === 2 ? "active" : "")}>
                                        <div className="row">
                                            <div className="mr-t-5"></div>
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label className="title1">اقلام تشکیل دهنده</label>
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                                <td>آیتم</td>
                                                                <td>واحد</td>
                                                                <td>
                                                                    <span>تعداد/مقدار</span>
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody></tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-default btn-smoke hand" onClick={e => this.closeMe()}>انصراف</button>
                                    <button type="submit" className="btn btn-success" onClick={e => this.save(e,false)}>
                                        ذخیره
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}